import { api } from './client';

export interface EasykitOplijsterProject {
  projectId: number;
  projectName: string;
  clientName: string;
  soName: string;
  soId: number;
  dateOrder: string;
  state: string;
}

export async function fetchEasykitOplijsterProjects(search?: string): Promise<EasykitOplijsterProject[]> {
  const params = search ? `?search=${encodeURIComponent(search)}` : '';
  const res = await api<{ projects: EasykitOplijsterProject[] }>(`/api/easykit-oplijster/projects${params}`);
  return res.projects;
}
